import { ContentFilterQueryParamKey, CONTENT_TILES_DEFAULT_COUNT, } from '@as-react/common-types';
import { LOCATION_CHANGE } from 'connected-react-router';
import { isNullOrUndefined, isMultiSelectFilter, isRangeFilter, isBucketFilter } from '@as-react/common-utils';
import { FilterActionTypes, UrlActionTypes } from '../../../enums/ActionEnums';
export const initialState = {};
const generateMultiSelectFilterValue = (filteredItems, filterDisplayHint) => {
    const useCommaSeparator = !isNullOrUndefined(filterDisplayHint) && filterDisplayHint.length > 0 && filterDisplayHint[0] === 'multiselect-and';
    return `(${filteredItems.map((item) => item.filterKey).join(`${useCommaSeparator ? ',' : ';'}`)})`;
};
const generateRangeFilterValue = (filteredItems) => {
    return `[${filteredItems.map((item) => item.filterKey).join(';')}]`;
};
const generateBucketFilterValue = (filteredItems) => {
    return `${filteredItems[filteredItems.length - 1].filterKey}`;
};
const generateTypeFilterValue = (filterObject) => filterObject.filteredItems.map((item) => `${filterObject.filterOn}:${item.filterKey}`);
const generateCategoryFilterValue = (filterObject) => {
    return `${filterObject.filterOn}:${filterObject.filteredItems[0].filterKey}`;
};
const removeUrlFilter = (initialFilter, action) => {
    if (!isNullOrUndefined(initialFilter)) {
        return [
            ...initialFilter.filter((urlFilterObject) => urlFilterObject.filterOn !== action.payload.filterOn),
        ];
    }
    return [];
};
const setUrlFilter = (state, action, generateFilterValue) => {
    return [
        ...removeUrlFilter(state.filter, action),
        {
            filterOn: action.payload.filterOn,
            filterValue: generateFilterValue(action.payload.filteredItems, action.payload.filterDisplayHint),
        },
    ];
};
const setFilters = (state, action) => {
    if (action.payload.queryParamKey === ContentFilterQueryParamKey.TYPE) {
        return Object.assign(Object.assign({}, state), { type: generateTypeFilterValue(action.payload), page: 0, size: CONTENT_TILES_DEFAULT_COUNT });
    }
    else if (action.payload.queryParamKey === ContentFilterQueryParamKey.CATEGORY) {
        return Object.assign(Object.assign({}, state), { category: generateCategoryFilterValue(action.payload), page: 0, size: CONTENT_TILES_DEFAULT_COUNT });
    }
    else if (isMultiSelectFilter(action.payload)) {
        return Object.assign(Object.assign({}, state), { filter: setUrlFilter(state, action, generateMultiSelectFilterValue), page: 0 });
    }
    else if (isRangeFilter(action.payload)) {
        return Object.assign(Object.assign({}, state), { filter: setUrlFilter(state, action, generateRangeFilterValue), page: 0 });
    }
    else if (isBucketFilter(action.payload)) {
        return Object.assign(Object.assign({}, state), { filter: setUrlFilter(state, action, generateBucketFilterValue), page: 0 });
    }
    return state;
};
const removeFilter = (state, action) => {
    if (action.payload.queryParamKey === ContentFilterQueryParamKey.TYPE) {
        return Object.assign(Object.assign({}, state), { type: [], page: 0, size: CONTENT_TILES_DEFAULT_COUNT });
    }
    else if (action.payload.queryParamKey === ContentFilterQueryParamKey.CATEGORY) {
        return Object.assign(Object.assign({}, state), { category: null, page: 0, size: CONTENT_TILES_DEFAULT_COUNT });
    }
    else {
        return Object.assign(Object.assign({}, state), { filter: removeUrlFilter(state.filter, action), page: 0 });
    }
};
export const loadUrlReducer = (initialData = {}) => {
    const initialReducerState = Object.assign(Object.assign({}, initialState), initialData);
    return (state = initialReducerState, action) => {
        switch (action.type) {
            case LOCATION_CHANGE:
                return action.payload.location && action.payload.location.state
                    ? Object.assign({}, action.payload.location.state.url) : state;
            case UrlActionTypes.SET_URL_PARAMS:
                return Object.assign(Object.assign({}, state), action.payload);
            case FilterActionTypes.SET_FILTERS:
                return setFilters(state, action);
            case FilterActionTypes.REMOVE_FILTER:
                return removeFilter(state, action);
            case FilterActionTypes.REMOVE_ALL_FILTERS:
                return Object.assign(Object.assign({}, state), { filter: [], category: null, type: [], page: 0, storeId: null });
            default:
                return state;
        }
    };
};
export const urlReducer = loadUrlReducer();
